import { render, staticRenderFns } from "./News.vue?vue&type=template&id=43269964&scoped=true&"
import script from "./News.vue?vue&type=script&lang=ts&"
export * from "./News.vue?vue&type=script&lang=ts&"
import style0 from "./News.vue?vue&type=style&index=0&id=43269964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43269964",
  null
  
)

export default component.exports